import React, { useState } from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label  } from 'reactstrap';

import styles from './index.module.scss';

const propTypes = {
    label: PropTypes.string,
    currentSelectionLabel: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
            label: PropTypes.string,
            className: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ])
        })
    ),
    isDisabled: PropTypes.bool,
    performSelection: PropTypes.func,
    classNames: PropTypes.string
};

const SearchableDropdown = ({ label, currentSelectionLabel, options, isDisabled, performSelection, classNames }) =>
{
    const [ searchPhrase, setSearchPhrase ] = useState('');
    const [ isOpen, setIsOpen ] = useState(false);
    const onChangeSearchPhrase = e =>
    {
        setSearchPhrase(e.target.value);
    };
    const handleToggle = () => { setIsOpen(!isOpen); };
    const handlePerformSelection = id => () => { performSelection(id); };

    return (
        <div className={clsx(styles.container, classNames)}>
            <Label>{label}</Label>
            <Dropdown
                direction="down"
                className={styles.dropdown}
                isOpen={isOpen}
                toggle={handleToggle}
                disabled={isDisabled}
            >
                <DropdownToggle caret className={styles.dropdownToggler} disabled={isDisabled}>
                    {currentSelectionLabel}
                </DropdownToggle>
                <DropdownMenu className={styles.dropdownMenu}>
                    <input
                        className={styles.search}
                        value={searchPhrase}
                        onChange={onChangeSearchPhrase}
                        type="text"
                    />
                    {
                        options
                            .filter(option =>
                                option.id === null || (option.label && option.label.toLowerCase().includes(searchPhrase.toLowerCase()))
                            )
                            .map(option =>
                                <DropdownItem key={`selector-${label}-${option.id}`} className={styles.dropdownItem} onClick={handlePerformSelection(option.id)}>
                                    <span className={option.className}>{option.label}</span>
                                </DropdownItem>
                            )
                    }
                </DropdownMenu>
            </Dropdown>
        </div>
    );
};

SearchableDropdown.propTypes = propTypes;

export default SearchableDropdown;